<template>
  <div class="frequent-product rounded-xl" @mouseenter="isHover = true" @mouseleave="isHover = false" :style="style">
    <div v-if="props.isFavorites&&product.supplierState=='OFF'" class="product-module"></div>
    <div class="product-top">
      <div class="product-top-info flex p-14" @click.stop="goProductDetail()" style="position: relative;">
        <div class="module-img" v-if="props.isFavorites&&product.supplierState=='OFF'">
          <div>商家</div>
          <div>已打烊</div>
        </div>
        <a-image :width="74" :height="74" :preview="false" style="border-radius: 4px" :src="product.absoluteThumbnailUrl" />
        <div class="product-info ml-8 pt-3">
          <div :class="['product-name truncate font-bold text-left', { 'mb-12': !props.showRetailPrice },{ 'module-name': props.isFavorites&&product.supplierState=='OFF' }]">
            <!-- {{ userInfo.isCollege ? product.productName : product.name }} -->
            {{ product.productName }}
          </div>
          <div v-if="props.showDelPrice">
            <!-- 删除按钮 start -->
            <div v-if="isHover" class="delete-product flex items-center justify-center">
              <img @click.stop="cancelCollect(product)" class="w-18 h-18" src="@/assets/personal/delete-icon.png" alt="" />
            </div>
            <!-- 删除按钮 end -->
          </div>
          <div class="product-price flex" v-if="!product.price">
            暂未报价
          </div>
          <div v-else>
            <div v-if="product.vipPrice">
              <div v-if="props.showRetailPrice" :class="['product-origin-price flex',{ 'module-name': props.isFavorites&&product.supplierState=='OFF' }]">
                零售价<span :class="['ml-4 mr-4',{ 'module-name': props.isFavorites&&product.supplierState=='OFF' }]">¥{{ toFixed2(product.price) }}</span>/{{ product.unitName }}{{product.priceType=='LADDER'?'起':''}}
              </div>
              <div class="product-price flex items-baseline m">
                <div class="memberrship-price-tip">专享价</div>
                <div class="ml-4 mr-4 memberrship-price">¥{{ toFixed2(product.vipPrice) }}</div>
                /{{ product.unitName }}{{product.priceType=='LADDER'?'起':''}}
              </div>
            </div>
            <div v-else :class="['product-price flex items-baseline',{ 'module-name': props.isFavorites&&product.supplierState=='OFF' }]">
                零售价<span :class="['ml-4 mr-4 memberrship-price',{ 'module-name': props.isFavorites&&product.supplierState=='OFF' }]">¥{{ toFixed2(product.price) }}</span>/{{ product.unitName }}{{product.priceType=='LADDER'?'起':''}}
            </div>
            <!-- <div class="product-price flex items-baseline mt-3">
                起购<span class="ml-4 mr-4">{{ product.minimumCount }}{{ product.unitName }}</span>
              </div> -->
          </div>
            
        </div>
      </div>
      <div v-if="!product.price" class="product-buy-btn-box align-center flex justify-between">
        <div class="product-buy-fill-btn mb-14 mx-14 align-center justify-center flex w-120"  @click.stop="inquireFun(product.supplierId)">我要询价</div>
      </div>
      <!-- userInfo.isCollege|| -->
      <div v-else class="product-buy-btn mb-14 mx-14 align-center" :class="{'disabled':userInfo.isSupplier||userInfo.isOrgwarehouse||userInfo.isRestaurant||(props.isFavorites&&product.supplierState=='OFF')}">
        <!-- !userInfo.isCollege&& -->
        <!-- <AddCartButton v-if="!userInfo.isSupplier" @addParentCart="addProductCart" :product="{ ...product, src: product.absoluteThumbnailUrl }"></AddCartButton>
        <div v-else class="disabled-cart">加入购物车</div> -->
        <div v-if="userInfo.isSupplier||userInfo.isOrgwarehouse||userInfo.isRestaurant" class="disabled-cart">加入购物车</div>
        <AddCartButton v-else @addParentCart="addProductCart" :product="{ ...product, src: product.absoluteThumbnailUrl }"></AddCartButton>

      </div>
    </div>
    <div class="product-btm flex items-center px-12 py-10" @click.stop="goProductStore">
      <img src="@/assets/home/store-icon.png" class="supplier-img mr-6" />
      <span :class="{ 'module-name': props.isFavorites&&product.supplierState=='OFF' }">{{ product.supplierName }}</span>
    </div>
  </div>
</template>

<script setup>
import AddCartButton from '@/components/com/addCartButton.vue'
import { useRouter } from 'vue-router'
import { ref, computed } from 'vue'
import _ from "lodash"
import { useStore } from 'vuex'
import api from '@/net/api'
import { message } from "ant-design-vue";
const store = useStore()
const productsCart = computed(() => store.state.productsCart.productsCart)
const userInfo = computed(() => store.state.user.userInfo)
const router = useRouter()
const emits = defineEmits(['cancelCollectFun'])
const isHover = ref(false)

const props = defineProps({
  //商品信息
  product: {
    required: true // 是否必传
  },
  //是否显示零售价
  showRetailPrice: {
    required: false,
    type: Boolean,
    default: true
  },
  //是否显示删除按钮
  showDelPrice: {
    required: false,
    type: Boolean,
    default: false
  },
  style: {
    required: false // 是否必传
    // type: Object,
    // default: ()=>{}
  },
  isFavorites: {
    required: false,
    type: Boolean,
    default: false
  },
})

// 处理价格
function dealVipPrice(){
  let discount = props.product.discounts||0
  if(props.product.priceType==='FIXED'){
    return props.product.price * (1-discount/100)
  }else if(props.product.priceType==='LADDER'){
    return (props.product?.productPriceDtos&&props.product?.productPriceDtos.length>0) ?(props.product?.productPriceDtos[0].price * (1-discount/100)):0
  }
  return 0
}

function addProductCart(product) {
  let _productsCart = _.cloneDeep(productsCart.value)
  let { supplierId, supplierName, deliveryFee, minDeliveryAmount } = product
  let productId = userInfo.value.isCollege?product.productId:product.id
  let index = _productsCart.findIndex(item=>item.supplierId === supplierId)
  if( index>-1 ){
    let pIndex =  _productsCart[index].productList.findIndex(pItem=>pItem.productId === productId)
    if(pIndex > -1){
      if(product.minimumCount>1){
        _productsCart[index].productList[pIndex].count = _productsCart[index].productList[pIndex].count + product.minimumCount
      }else{
        _productsCart[index].productList[pIndex].count = _productsCart[index].productList[pIndex].count + 1
      }
    }else{
      _productsCart[index].productList.push({count:product.minimumCount,...product,productId,checked:false,isInValid: false,})
    }
  }else{
    _productsCart.push({
      supplierId,supplierName,indeterminate: false,isInValid: false,deliveryFee, minDeliveryAmount,_deliveryFee:deliveryFee,
      checkAll: false,productList:[{count:product.minimumCount,...product,productId,checked:false,isInValid: false,}]
    })
  }
  store.dispatch('set_productsCart',_productsCart)
}
// 商品详情
function goProductDetail() {
  // let productId = userInfo.value.isCollege?props.product.productId:props.product.id
  let productId = props.product.productId
  if(productId && props.product.supplierId){
    router.push('/main/productInfo?id='+productId+'&storeId='+props.product.supplierId)
  }else{
    message.warning('跳转失败，请重试')
  }
}
// 去店铺
function goProductStore(){
  if(props.product.supplierId){
    router.push('/main/store/detail?id='+props.product.supplierId)
  }else{
    message.warning('跳转失败，请重试')
  }
}
// 取消收藏
function cancelCollect(product){
  emits('cancelCollectFun', product)
}
// 我要询价
function inquireFun(supplierId){
  api.info_supplier_getUserSign({supplierId}).then((res) => {
    console.log(res)
    router.push('/main/personalCenter/message?code='+res)
  })
}
</script>

<style lang="scss" scoped>
.frequent-product {
  width: 100%;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;

  .product-top {
    border-bottom: 1px solid #eeeeee;
    .module-img{
      position: absolute;
      z-index: 1;
      background: #000;
      opacity: 0.5;
      /* width: 100%; */
      /* height: 100%; */
      width: 74px;
      height: 74px;
      padding-top: 16px;
      font-size: 14px;
      color: #FFFFFF;
    }
    :deep(.ant-image) {
      flex-shrink: 0;
      .ant-image-img {
        height: 100%;
      }
    }

    .product-info {
      flex: 1;
      width: 0;
    }
    .delete-product {
      width: 28px;
      height: 28px;
      background: rgba($color: #000000, $alpha: 0.4);
      border-radius: 4px;
      position: absolute;
      top: 5px;
      right: 5px;
    }
    .product-name {
      width: 100%;
      font-size: 16px;
    }
    .module-name{
      color: #BBBBBB !important;
    }
    .product-origin-price {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #999999;
      text-decoration: line-through;
      margin: 6px 0;
    }

    .product-price {
      font-size: 12px;
      color: #666666;

      .memberrship-price-tip {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #ff2222;
      }

      .memberrship-price {
        font-size: 14px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        color: #ff2222;
      }
    }

    .product-buy-btn {
      height: 34px;
      background: #00cca0;
      border-radius: 4px;
      border: 1px solid #00cca0;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      line-height: 32px;
      &.disabled{
        background-color: #c3c0c0;
        border: 1px solid #c3c0c0;
        color: #ffffff;
        cursor: not-allowed;
      }
    }
  }
  .product-module{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #F6F6F6;
    z-index: 2;
    opacity: 0.4;
  }
  .product-buy-fill-btn{
    width: 100%;
    height: 34px;
    background: #00cca0;
    border-radius: 4px;
    border: 1px solid #00cca0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    line-height: 32px;
  }
  .product-btm {
    .module-name{
      color: #BBBBBB !important;
    }
    .supplier-img {
      width: 16px;
      height: 16px;
    }
    span {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #666666;
    }
  }
}
</style>
